import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { TELEMATIK_INFRASTRUCTURE_SIGNING_MUTATION_PARAMS } from "@/modules/patients/detail/conclude/services/telematikInfrastructureSigningMutationParams"
import {
  De_signAttestationGuardianDocumentWithTelematikInfrastructureInput,
  useDeSignLegalGuardianWithTelematikInfrastructureMutation as useDeSignLegalGuardianWithTelematikInfrastructureMutationType,
} from "@/modules/patients/detail/legal-guardian-attestation/de/services/__generated__/useDeSignLegalGuardianWithTelematikInfrastructureMutation.graphql"

const mutation = graphql`
  mutation useDeSignLegalGuardianWithTelematikInfrastructureMutation(
    $input: De_signAttestationGuardianDocumentWithTelematikInfrastructureInput!
  ) {
    de_signAttestationGuardianDocumentWithTelematikInfrastructure(input: $input) {
      de_AttestationGuardian {
        id
        createdAt
        createdBy
        signedBy
        signedAt
        updatedAt
        updatedBy
        fileId
      }
      errors {
        __typename
        ... on Error {
          message
        }
        ... on SignDocumentMutationFailed {
          errorType
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useDeSignLegalGuardianWithTelematikInfrastructureMutationType>, "variables"> & {
  id: De_signAttestationGuardianDocumentWithTelematikInfrastructureInput["id"]
}

const useDeSignLegalGuardianWithTelematikInfrastructureMutation = () => {
  const [commit, isFlight] = useMutationWithErrorDialog<useDeSignLegalGuardianWithTelematikInfrastructureMutationType>(
    mutation,
    TELEMATIK_INFRASTRUCTURE_SIGNING_MUTATION_PARAMS,
  )

  const commitHandler = useCallback(
    async (config: Config) => {
      commit({
        variables: {
          input: {
            id: config.id,
          },
        },
        ...config,
      })
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useDeSignLegalGuardianWithTelematikInfrastructureMutation }
